import Avatar from '@mui/material/Avatar';
import UserProfileBtn from 'molecules/UserProfileBtn';
import React from 'react';
import { useUserAuth } from 'utils/hooks/useUserAuth';

import s from './Navigation.module.scss';

interface IProfileNav {
  name: string;
  isOfferingDetailsSticky?: boolean;
  transparent: boolean;
  dark: boolean;
  isSticky?: boolean;
  onAction: (actionName: string, url?: string) => void;
}

const ProfileNav = ({ name, transparent, dark, isSticky, onAction }: IProfileNav) => {
  const authDetails = useUserAuth();

  return (
    <>
      <div className={s.Navigation__avatarHolder}>
        <Avatar
          className={s.Navigation__avatar}
          onClick={() => onAction('open_profile', '/profile/personal')}
          variant="rounded"
        >
          {authDetails?.name?.split(' ')[0][0]?.toUpperCase() || 'P'}
        </Avatar>
      </div>
      <UserProfileBtn className={s.Navigation__profileBtn} />
    </>
  );
};

export default ProfileNav;
